/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateDocumentCtaRequestDocumentCtaFromJSON, UpdateDocumentCtaRequestDocumentCtaToJSON } from './UpdateDocumentCtaRequestDocumentCta';
export function UpdateDocumentCtaRequestFromJSON(json) {
    return UpdateDocumentCtaRequestFromJSONTyped(json, false);
}
export function UpdateDocumentCtaRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentCta: !exists(json, 'document_cta')
            ? undefined
            : UpdateDocumentCtaRequestDocumentCtaFromJSON(json['document_cta'])
    };
}
export function UpdateDocumentCtaRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_cta: UpdateDocumentCtaRequestDocumentCtaToJSON(value.documentCta)
    };
}
